<template>
  <div class="image-upload">
    <el-upload
      class="upload-demo"
      action=""
      :http-request="handleUpload"
      :show-file-list="false"
      :before-upload="beforeUpload"
      accept="image/*"
    >
      <el-button size="small" type="primary">点击上传图片</el-button>
    </el-upload>
    <div v-if="imageUrl" class="image-preview">
      <img :src="imageUrl" alt="图片预览" style="max-width: 100%; max-height: 200px; margin-top: 10px;" />
    </div>
  </div>
</template>

<script>
import { uploadImage } from '@/api/upload'

export default {
  name: 'ImageUpload',
  props: {
    value: String // 支持 v-model
  },
  data() {
    return {
      imageUrl: this.value || ''
    }
  },
  watch: {
    value(val) {
      this.imageUrl = val
    }
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt15M = file.size / 1024 / 1024 < 15
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt15M) {
        this.$message.error('图片大小不能超过 15MB!')
      }
      return isImage && isLt15M
    },
    async handleUpload(option) {
      try {
        const res = await uploadImage(option.file)
        this.imageUrl = res.url
        this.$emit('input', res.url)
        this.$message.success('上传成功!')
      } catch (e) {
        this.$message.error('上传失败!')
      }
    }
  }
}
</script>

<style scoped>
.image-upload {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.image-preview {
  margin-top: 10px;
}
</style>
